export const API_URLS = {
  getBuySellAssets: "api/v1/buysell/get_public_pairs?is_swap=0",
  contactUs:"user/api/v1/user/supportSubmit"
};
